import { Product } from "./product";

type Fee = {
  id: number;
  name: string;
  subtotal: number;
  tax: number;
  taxPercent: number;
  total: number;
};

type EditBasketPayloadType = {
  lineId: string;
  item: Product;
  variationId?: number;
  quantity: number;
};

type DeleteBasketPayloadType = {
  lineId: string;
};

export { Fee, EditBasketPayloadType, DeleteBasketPayloadType };
